import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    DownloadLineCardApiParameter,
    DownloadLineCardModel,
    downloadLineCardModelService,
} from "@tCentro/Services/CENLineCardService";

type HandlerType = ApiHandlerDiscreteParameter<
    DownloadLineCardModel & HasOnSuccess,
    DownloadLineCardApiParameter,
    DownloadLineCardModel
>;

export const PopulateApiParameter: HandlerType = props => {
    const downloadLineCardModel = props.parameter;
    props.apiParameter = { downloadLineCardModel };
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await downloadLineCardModelService(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const downloadLineCard = createHandlerChainRunner(chain, "CENDownloadLineCard");
export default downloadLineCard;
